var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173.48,
    height: 34.865,
    viewBox: "0 0 173.48 34.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.519H173.48V-28.346H0Z",
    transform: "translate(0 28.346)",
    fill: "#20c1f1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.519H173.48V-28.346H0Z",
    transform: "translate(0 28.346)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -28.346)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.171.915A2.385,2.385,0,0,0,.938-.759a5.48,5.48,0,0,0-2.578-.508c-2.182,0-3.482.662-3.482,1.764,0,.836.573,1.212,2.138,1.365l3.571.375a9.97,9.97,0,0,1,3.9.925A3.935,3.935,0,0,1,6.667,6.731,4.511,4.511,0,0,1,4,10.786a12.1,12.1,0,0,1-5.443.969c-3,0-5.112-.573-6.456-1.742-1.036-.881-1.41-1.85-1.542-3.79h3.856a2.49,2.49,0,0,0,.969,1.94,5.234,5.234,0,0,0,3.349.881c2.4,0,3.791-.7,3.791-1.916C2.524,6.159,1.8,5.673.078,5.5l-4.143-.418C-7.281,4.748-9.023,3.295-9.023.959c0-3.063,2.82-4.936,7.4-4.936A10.538,10.538,0,0,1,4.111-2.545,4.53,4.53,0,0,1,6.049.915Z",
    transform: "translate(9.441 3.977)",
    fill: "#20c1f1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.864 10.051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.018,2.155-.349,5.328H-4.425L2.56-9.369H6.174l6.963,14.7H9.017L7.54,2.155ZM5.073-3.111c-.419-.9-.617-1.367-.9-2.05-.287.706-.352.883-.859,2.095L2.34-.819H6.174Z",
    transform: "translate(4.425 9.369)",
    fill: "#20c1f1"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.066 -18.294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.748v-14.7H12.89v2.974H3.68V-6.22h8.461v2.974H3.68V2.748Z",
    transform: "translate(0 11.948)",
    fill: "#20c1f1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.189 -18.294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.748v-14.7H13.44v2.974H3.68v2.489h8.637V-3.51H3.68V-.226h9.76V2.748Z",
    transform: "translate(0 11.948)",
    fill: "#20c1f1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -28.346)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.496 3.235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.308,2.654a14.211,14.211,0,0,0-14.2-14.2,14.211,14.211,0,0,0-14.2,14.2,14.211,14.211,0,0,0,14.2,14.2,14.211,14.211,0,0,0,14.2-14.2m-4.234,0a9.973,9.973,0,0,1-9.962,9.962,9.973,9.973,0,0,1-9.963-9.962A9.973,9.973,0,0,1-8.887-7.308,9.973,9.973,0,0,1,1.075,2.654",
    transform: "translate(23.083 11.542)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.305 10.051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H8.748c2.512,0,3,.044,3.855.4a3.44,3.44,0,0,1,1.984,3.283,3.505,3.505,0,0,1-1.9,3.151,3.84,3.84,0,0,1,2.579,3.68,3.915,3.915,0,0,1-2.226,3.612c-1.013.464-1.9.573-4.187.573H0ZM8.659,5.817c1.411,0,1.961-.4,1.961-1.454s-.55-1.455-1.961-1.455H3.68V5.817Zm0,5.972a3.951,3.951,0,0,0,1.851-.264,1.516,1.516,0,0,0,.792-1.433,1.5,1.5,0,0,0-.792-1.41,3.678,3.678,0,0,0-1.851-.264H3.68v3.371Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.115 -18.294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.237,2.748-1.332-2.033-5.144,2.748H-9.727L-3.6-4.766l-6.125-7.182h4.914l3.481,4.626,3.569-4.626H6.821L.916-4.766,7.04,2.748Z",
    transform: "translate(9.727 11.948)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.677 -18.294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.748v-14.7H13.441v2.974H3.68v2.489h8.637V-3.51H3.68V-.226h9.761V2.748Z",
    transform: "translate(0 11.948)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -28.346)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.375 9.544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.171.915A2.385,2.385,0,0,0,.937-.759a5.477,5.477,0,0,0-2.578-.508c-2.182,0-3.482.662-3.482,1.764,0,.836.573,1.212,2.138,1.365l3.571.375a9.97,9.97,0,0,1,3.9.925A3.933,3.933,0,0,1,6.667,6.731,4.508,4.508,0,0,1,4,10.786a12.1,12.1,0,0,1-5.443.969c-3,0-5.112-.573-6.456-1.742-1.034-.881-1.41-1.85-1.541-3.79h3.855a2.487,2.487,0,0,0,.97,1.94,5.23,5.23,0,0,0,3.348.881c2.4,0,3.791-.7,3.791-1.916C2.524,6.159,1.8,5.673.079,5.5l-4.143-.418C-7.281,4.748-9.022,3.295-9.022.959c0-3.063,2.82-4.936,7.4-4.936A10.538,10.538,0,0,1,4.111-2.545,4.53,4.53,0,0,1,6.049.915Z",
    transform: "translate(9.44 3.977)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.261 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.739,1.985H4.176A17.431,17.431,0,0,0-11.871-8.633,17.432,17.432,0,0,0-29.3,8.8,17.432,17.432,0,0,0-11.871,26.233,17.438,17.438,0,0,0,4.178,15.616H6.739L12.466,8.8ZM-11.872,24.136A15.353,15.353,0,0,1-27.206,8.8,15.354,15.354,0,0,1-11.872-6.536,15.354,15.354,0,0,1,3.464,8.8,15.353,15.353,0,0,1-11.872,24.136",
    transform: "translate(29.303 8.633)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.608 10.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.527.764A4.116,4.116,0,0,0-4.4-2.913,3.683,3.683,0,0,0-6.259-1.026a4.124,4.124,0,0,0,2.087,5.54v6.948H-.944V4.515A4.086,4.086,0,0,0,1.527.764",
    transform: "translate(6.641 3.321)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.80c8286c8c03360073339e30708a0181.svg";
export { ForwardRef as ReactComponent };